<div class="con">
<div id="reno-bg">

</div>
<ng-container *ngIf="(globalService.langChosen=='ar')?true:false; else english">
  <div class="language-button" (click)="languageChange('en')">
    <div class="lang-container">
      <img src="assets/img/oppo-golf/united-kingdom.png" alt="">
      <p>english</p>

    </div>


  </div>
</ng-container>
<ng-template #english>

  <div class="language-button" (click)="languageChange('ar')">
    <div class="lang-container">
    <img src="assets/img/oppo-golf/united-arab-emirates.png" alt="">
      <p>العربية</p>
    </div>
  </div>
</ng-template>


  <ng-container *ngIf="(globalService.langChosen=='ar')?true:false; else banner">
<a target="_blank" class="reno-cup-banner"  href="https://www.gbarena.com/events/reno-6-pubg-mobile-cup-gulf/tournaments">
  <img src="assets/img/oppo-golf/Landing-Page-Banner-Desktop.jpg" class="img-responsive  hidden-xs" >
  <img src="assets/img/oppo-golf/Landing-Page-Banner-Mobile.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" alt="">
</a>
  </ng-container>
  <ng-template #banner>
    <a target="_blank" class="reno-cup-banner"  href="https://www.gbarena.com/events/reno-6-pubg-mobile-cup-gulf/tournaments">
      <img src="assets/img/oppo-golf/Landing-Page-Banner-Desktop-En.jpg" class="img-responsive  hidden-xs" >
      <img src="assets/img/oppo-golf/Landing-Page-Banner-Mobile-EN.jpg" class="img-responsive hidden-lg hidden-md hidden-sm" alt="">
    </a>
  </ng-template>
<perfect-scrollbar class="scroll-x-container">
  <div class="menu-container" [ngClass]="{'rtl': (globalService.langChosen=='ar')?true:false}">
    <div class="container" >
      <div class="menu">
        <div class="item" routerLink="./tournaments" routerLinkActive="active">
          <p>{{globalService.customLang.tournament}}</p>
        </div>
        <div class="item" routerLink="./qualified-player" routerLinkActive="active">
          <p>{{globalService.customLang.qualified_player}}</p>
        </div>
        <div class="item" routerLink="./rules-terms" routerLinkActive="active">
          <p>{{globalService.customLang.rules_terms}}</p>
        </div>
        <div class="item" routerLink="./prizes" routerLinkActive="active">
          <p>{{globalService.customLang.prizes}}</p>
        </div>
      </div>
    </div>

  </div>
</perfect-scrollbar>
  <div class="banner_container"  >
    <a target="_blank" href="https://www.oppo.com/ae/smartphones/series-reno/reno6-pro-5g/?utm_medium=display&utm_source=website&utm_campaign=arab_hardware-ae_ar-oppo_reno6_pro_5g-reno6_pubg_cup-20211025_to_20211131-awareness&utm_content=image&utm_term=oppo_reno5">
      <img class="img-responsive hidden-xs" src="assets/img/oppo-egypt/Artboard-1.jpg" alt=""  >
      <img src="assets/img/oppo-egypt/Artboard%204.png" class="img-responsive  hidden-lg hidden-md hidden-sm" alt="">

    </a>
  </div>
  <router-outlet></router-outlet>


<app-oppo-gulf-footer></app-oppo-gulf-footer>
</div>
